// import { useState, useEffect } from 'react'
// import { fetchSessions } from '../api/client'

// function timeAgo(isoStr) {
//     if (!isoStr) return ''
//     const normalized = isoStr.endsWith('Z') || isoStr.includes('+') ? isoStr : isoStr + 'Z'
//     const diff = Date.now() - new Date(normalized).getTime()
//     const mins = Math.floor(diff / 60000)
//     const hours = Math.floor(diff / 3600000)
//     const days = Math.floor(diff / 86400000)
//     if (mins < 1) return 'just now'
//     if (mins < 60) return `${mins}m ago`
//     if (hours < 24) return `${hours}h ago`
//     return `${days}d ago`
// }

// export default function Sidebar({ context, onNewChat, onLoadSession, activeSessionId }) {
//     const [sessions, setSessions] = useState([])
//     const [loadingSessions, setLoadingSessions] = useState(true)

//     useEffect(() => {
//         if (!context.token) return
//         fetchSessions(context.token)
//             .then(setSessions)
//             .catch(() => setSessions([]))
//             .finally(() => setLoadingSessions(false))
//     }, [context.token])

//     return (
//         <aside className="sidebar">
//             <div className="sidebar-inner">

//                 <div className="sidebar-top">
//                     <div className="sidebar-brand">MSR AI</div>
//                     <button className="new-chat-btn" onClick={onNewChat}>
//                         + New chat
//                     </button>
//                 </div>

//                 {/* <div className="sidebar-user">
//                     <div className="user-email">{context.user?.email}</div>
//                     <div className="user-meta">
//                         {context.user?.is_admin ? 'Admin' : `Role ${context.user?.role_id}`} · Org {context.user?.org_id}
//                     </div>
//                 </div> */}

//                 <div className="sidebar-section">
//                     <div className="sidebar-label">Recent chats</div>
//                     {loadingSessions ? (
//                         <div className="sidebar-empty">Loading...</div>
//                     ) : sessions.length === 0 ? (
//                         <div className="sidebar-empty">No history yet</div>
//                     ) : (
//                         <ul className="session-list">
//                             {sessions.map(s => (
//                                 <li
//                                     key={s.session_id}
//                                     className={`session-item ${activeSessionId === s.session_id ? 'active' : ''}`}
//                                     onClick={() => onLoadSession(s.session_id)}
//                                     title={s.title}
//                                 >
//                                     <div className="session-title">{s.title}</div>
//                                     <div className="session-meta">
//                                         {timeAgo(s.created_at)} · {s.message_count} msg{s.message_count !== 1 ? 's' : ''}
//                                     </div>
//                                 </li>
//                             ))}
//                         </ul>
//                     )}
//                 </div>

//             </div>
//         </aside>
//     )
// }

















import { useState, useEffect, useRef } from 'react'
import { MoreVertical, Pencil, Trash2, Check, X } from 'lucide-react'
import { fetchSessions, renameSession, deleteSession } from '../api/client'

function timeAgo(isoStr) {
    if (!isoStr) return ''
    const normalized = isoStr.endsWith('Z') || isoStr.includes('+') ? isoStr : isoStr + 'Z'
    const diff = Date.now() - new Date(normalized).getTime()
    const mins = Math.floor(diff / 60000)
    const hours = Math.floor(diff / 3600000)
    const days = Math.floor(diff / 86400000)
    if (mins < 1) return 'just now'
    if (mins < 60) return `${mins}m ago`
    if (hours < 24) return `${hours}h ago`
    return `${days}d ago`
}

export default function Sidebar({ context, onNewChat, onLoadSession, onSessionDeleted, activeSessionId, refreshKey }) {
    const [sessions, setSessions] = useState([])
    const [loadingSessions, setLoadingSessions] = useState(true)
    const [openMenuId, setOpenMenuId] = useState(null)
    const [renamingId, setRenamingId] = useState(null)
    const [renameValue, setRenameValue] = useState('')
    const [confirmDeleteId, setConfirmDeleteId] = useState(null)
    const menuRef = useRef(null)
    const renameInputRef = useRef(null)

    useEffect(() => {
        if (!context.token) return
        fetchSessions(context.token)
            .then(setSessions)
            .catch(() => setSessions([]))
            .finally(() => setLoadingSessions(false))
    }, [context.token, refreshKey])

    useEffect(() => {
        function handleClickOutside(e) {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setOpenMenuId(null)
                setConfirmDeleteId(null)
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    useEffect(() => {
        if (renamingId && renameInputRef.current) {
            renameInputRef.current.focus()
            renameInputRef.current.select()
        }
    }, [renamingId])

    function toggleMenu(e, sessionId) {
        e.stopPropagation()
        setConfirmDeleteId(null)
        setOpenMenuId(prev => (prev === sessionId ? null : sessionId))
    }

    function startRename(e, session) {
        e.stopPropagation()
        setOpenMenuId(null)
        setRenamingId(session.session_id)
        setRenameValue(session.title)
    }

    async function commitRename(sessionId) {
        const trimmed = renameValue.trim()
        setRenamingId(null)
        if (!trimmed) return

        const prevSessions = sessions
        setSessions(prev => prev.map(s => s.session_id === sessionId ? { ...s, title: trimmed } : s))

        try {
            await renameSession(context.token, sessionId, trimmed)
        } catch (err) {
            setSessions(prevSessions)
            console.error('Rename failed', err)
        }
    }

    function handleRenameKeyDown(e, sessionId) {
        if (e.key === 'Enter') {
            e.preventDefault()
            commitRename(sessionId)
        } else if (e.key === 'Escape') {
            setRenamingId(null)
        }
    }

    function askDelete(e, sessionId) {
        e.stopPropagation()
        setConfirmDeleteId(sessionId)
    }

    async function confirmDelete(e, sessionId) {
        e.stopPropagation()
        const prevSessions = sessions
        setSessions(prev => prev.filter(s => s.session_id !== sessionId))
        setOpenMenuId(null)
        setConfirmDeleteId(null)

        try {
            await deleteSession(context.token, sessionId)
            if (activeSessionId === sessionId && onSessionDeleted) {
                onSessionDeleted(sessionId)
            }
        } catch (err) {
            setSessions(prevSessions)
            console.error('Delete failed', err)
        }
    }

    return (
        <aside className="sidebar">
            <div className="sidebar-inner">

                <div className="sidebar-top">
                    <div className="sidebar-brand">MSR AI</div>
                    <button className="new-chat-btn" onClick={onNewChat}>
                        + New chat
                    </button>
                </div>

                <div className="sidebar-section">
                    <div className="sidebar-label">Recent chats</div>
                    {loadingSessions ? (
                        <div className="sidebar-empty">Loading...</div>
                    ) : sessions.length === 0 ? (
                        <div className="sidebar-empty">No history yet</div>
                    ) : (
                        <ul className="session-list" ref={menuRef}>
                            {sessions.map(s => (
                                <li
                                    key={s.session_id}
                                    className={`session-item ${activeSessionId === s.session_id ? 'active' : ''}`}
                                    onClick={() => renamingId !== s.session_id && onLoadSession(s.session_id)}
                                    title={s.title}
                                >
                                    <div className="session-item-row">
                                        {renamingId === s.session_id ? (
                                            <div className="session-rename-row" onClick={e => e.stopPropagation()}>
                                                <input
                                                    ref={renameInputRef}
                                                    className="session-rename-input"
                                                    value={renameValue}
                                                    onChange={e => setRenameValue(e.target.value)}
                                                    onKeyDown={e => handleRenameKeyDown(e, s.session_id)}
                                                    maxLength={100}
                                                />
                                                <button
                                                    className="session-icon-btn"
                                                    onClick={() => commitRename(s.session_id)}
                                                    aria-label="Save"
                                                >
                                                    <Check size={14} />
                                                </button>
                                                <button
                                                    className="session-icon-btn"
                                                    onClick={() => setRenamingId(null)}
                                                    aria-label="Cancel"
                                                >
                                                    <X size={14} />
                                                </button>
                                            </div>
                                        ) : (
                                            <div className="session-title">{s.title}</div>
                                        )}

                                        {renamingId !== s.session_id && (
                                            <button
                                                className="session-menu-btn"
                                                onClick={e => toggleMenu(e, s.session_id)}
                                                aria-label="Session options"
                                            >
                                                <MoreVertical size={16} />
                                            </button>
                                        )}
                                    </div>

                                    <div className="session-meta">
                                        {timeAgo(s.created_at)} · {s.message_count} msg{s.message_count !== 1 ? 's' : ''}
                                    </div>

                                    {openMenuId === s.session_id && (
                                        <div className="session-menu" onClick={e => e.stopPropagation()}>
                                            {confirmDeleteId === s.session_id ? (
                                                <>
                                                    <div className="session-menu-confirm-text">Delete this chat?</div>
                                                    <button
                                                        className="session-menu-item danger"
                                                        onClick={e => confirmDelete(e, s.session_id)}
                                                    >
                                                        <Trash2 size={14} />
                                                        Confirm delete
                                                    </button>
                                                    <button
                                                        className="session-menu-item"
                                                        onClick={e => { e.stopPropagation(); setConfirmDeleteId(null) }}
                                                    >
                                                        <X size={14} />
                                                        Cancel
                                                    </button>
                                                </>
                                            ) : (
                                                <>
                                                    <button
                                                        className="session-menu-item"
                                                        onClick={e => startRename(e, s)}
                                                    >
                                                        <Pencil size={14} />
                                                        Rename
                                                    </button>
                                                    <button
                                                        className="session-menu-item danger"
                                                        onClick={e => askDelete(e, s.session_id)}
                                                    >
                                                        <Trash2 size={14} />
                                                        Delete
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    )}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

            </div>
        </aside>
    )
}